import { getPhotoType } from "./getPhotoType";
import { Photo } from "./types/photo";
import { PhotoType } from "./types/photoType";

export interface PhotoAndCaption {
  caption: string | null;
  photo: Photo;
}

export function getPhotoAndCaptions(
  photoTypes: PhotoType[],
  photos: Photo[]
): PhotoAndCaption[] {
  const result: PhotoAndCaption[] = [];

  for (const photo of photos) {
    const matchingPhotoType = getPhotoType(photoTypes, photo);
    const photoWithCaption = {
      caption: matchingPhotoType.text,
      photo,
    };
    result.push(photoWithCaption);
  }
  return result;
}
